import React from "react";

import { TEmployeePosition } from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/model/types";

import PositionViewItem from "./PositionViewItem";

interface IPositionsViewSectionProps {
  employeeId: string;
  positions: TEmployeePosition[];
  refetch: () => void;
}

const PositionsViewSection = ({
  employeeId,
  positions,
  refetch,
}: IPositionsViewSectionProps) => (
  <>
    {positions.map((position, index) => (
      <PositionViewItem
        key={`${position.number}-${index}`}
        position={position}
        employeeId={employeeId}
        refetch={refetch}
      />
    ))}
  </>
);

export default PositionsViewSection;
